import styled from 'styled-components';
import React, { useState } from 'react';
import { HALF_CONTRAST, CONTRAST } from '../../theme';
import { formatLabel } from './formats';

const OPERATOR_LABEL = {
  eq: '',
  gte: 'Greater than ',
  lte: 'Less than ',
};

const FilterLabel = styled.div`
  color: ${HALF_CONTRAST};
  font-size: 13px;
  font-weight: 600;
  padding: 0 4px 0 0;
  cursor: pointer;
  display: flex;
  align-items: ${({ horizontal }) => (horizontal ? 'center' : 'flex-start')};
`;

const SmallLabel = styled.div`
  color: ${CONTRAST};
  padding: 2px 4px;
  padding-left: ${({ horizontal }) => (horizontal ? '4px' : '0')};
  font-size: 12px;
`;

const FilterDescription = styled.div`
  display: flex;
  padding: 0 4px 0 0;
  align-items: ${({ horizontal }) => (horizontal ? 'center' : 'flex-start')};
  flex-direction: ${({ horizontal }) => (horizontal ? 'row' : 'column')};
`;

const Pill = styled.div`
  color: ${HALF_CONTRAST};
  padding: 4px;
  border: 1px solid ${HALF_CONTRAST};
  border-radius: 8px;
  margin: 2px 4px 2px 0;
  font-size: 12px;
  word-break: break-word;
  flex-direction: ${({ horizontal }) => (horizontal ? 'row' : 'column')};
`;
const Pills = styled.div`
  flex-direction: row;
  display: flex;
  flex-wrap: wrap;
`;

const Section = styled.div`
  flex-direction: ${({ horizontal }) => (horizontal ? 'row' : 'column')};
  align-items: ${({ horizontal }) => (horizontal ? 'center' : 'flex-start')};
  flex-wrap: wrap;

  display: flex;
  padding-bottom: 12px;

  &:last-of-type {
    padding-bottom: 0;
  }
`;

export const LayerFilters = ({ layer, filterDefinitions }) => {
  const [open, setOpen] = useState(true);
  return (
    <Section>
      <FilterLabel onClick={() => setOpen(!open)}>{layer.label}</FilterLabel>
      {open ? (
        <FilterPills layer={layer} filterDefinitions={filterDefinitions} />
      ) : null}
    </Section>
  );
};

export const FilterPills = ({ layer, filterDefinitions, horizontal }) => Object
  .entries(layer.filters).map(([filterKey, selectedFilters]) => {
    const filterDefinition = filterDefinitions.reduce((acc, def) => {
      if (def.type === 'PARENT') {
        return (
          def.filters.find((innerDef) => innerDef.key === filterKey) || acc
        );
      }
      if (def.key === filterKey) return def;
      return acc;
    }, null);

    const titleEl = (
      <SmallLabel horizontal={horizontal}>{filterDefinition.label}</SmallLabel>
    );
    const filterEls = Object.entries(selectedFilters).map(
      ([operator, values]) => {
        if (!Array.isArray(values)) {
          return (
            <Pill key={`${operator}-${values}`} horizontal={horizontal}>
              {`${OPERATOR_LABEL[operator] || ''}${formatLabel(values, filterDefinition.unit, filterDefinition.map)}`}
            </Pill>
          );
        }


        return values.map((value) => {
          const displayValue = filterDefinition.options
            ? (filterDefinition.options
              .filter(Boolean)
              .find(opt => `${opt.value}` === `${value}`) || {}).label
            : value;

          return (
            <Pill key={`${operator}-${value}`} horizontal={horizontal}>
              {`${OPERATOR_LABEL[operator] || ''}${formatLabel(displayValue, filterDefinition.unit, filterDefinition.map)}`}
            </Pill>
          );
        });
      },
    );

    return (
      <FilterDescription
        key={`${layer.key}-${filterKey}`}
        horizontal={horizontal}
      >
        {titleEl}
        <Pills horizontal={horizontal}>
          {filterKey === 'area_filter' ? null : filterEls}
        </Pills>
      </FilterDescription>
    );
  });
